export default __webpack_public_path__ + "static/media/new_ebis1.cacaba61.png";